module.exports = __webpack_public_path__ + "static/media/girl-three.d9b1e0d4.jpg";